import axios from "axios";
import axiosInstance from "../../../Axios/Axios";

const GetAllActivePersonByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/Person/GetAllActivePersonByTenantId?tenantId=${tenantId}`
  );
};

const GetAllActivePersonsByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/Person/GetAllActivePersonsByTenantId?tenantId=${tenantId}`
  );
};

const GetAllHorizontalAlignmentByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  let periodId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/GetAllHorizontalAlignmentByTenantId/?tenantId=${tenantId}&definitionLevelId=${periodId}`
  );
};

const getAllObjectiveNameWithKeyResultsByTenantId = async ({
  queryKey,
}: any) => {
  let ids: any | null = queryKey[1];
  return await axiosInstance.get(
    `OKR/GetAllObjectiveNameWithKeyResultsByTenantId/?tenantId=${ids.tenantId}&definitionLevelId=${ids.definitionLevelId}&periodId=${ids.periodId}`
  );
};

// https://api.myokr.ir/api/OKR/GetAllOKRStateByTenantId?tenantId=eb781974-3cb0-4c3a-881e-97af686ce7f5

const GetAllOKRStateByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/OKR/GetAllOKRStateByTenantId?tenantId=${tenantId}`
  );
};

const GetAllScoreLevelsByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/OKR/GetAllScoreLevelsByTenantId?tenantId=${tenantId}`
  );
};

const AddKeyResult = async (krData: any) => {
  return await axiosInstance.post("OKR/AddKeyResult", krData);
};

const getAllObjectivePeriodsByTenantId = async () => {
  return await axiosInstance.get(
    "OKR/getAllPeriodsByTenantId?tenantId=3f2d72cf-cdff-413c-abcd-d5459d97890c"
  );
};

const getAllObjectiveByPeriodId = async ({ queryKey }: any) => {
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/GetAllVerticalAlignmentByTenantId/?tenantId=${profileTenantId}&periodId=${periodId}`
  );
};

const getStrategyMapTenantId = async ({ queryKey }: any) => {
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/GetStrategyMapTenantId/?tenantId=${profileTenantId}&periodId=${periodId}`
  );
};

const getAllObjectiveByPeriodId1 = async ({ queryKey }: any) => {
    let periodId = queryKey[1];
    let profileTenantId = queryKey[2];
    return await axiosInstance.get(
      `/OKR/GetOKRTreeByTenantId/?tenantId=${profileTenantId}&periodId=${periodId}`
    );
  };
  
  const getAllObjectiveByPeriodId2 = async ({ queryKey }: any) => {
    let profileTenantId = queryKey[1];
    return await axiosInstance.get(
      `/Team/GetTeamTreeByTenantId/?tenantId=${profileTenantId}`
    );
  };
  
  const GetPersonAndTeamCountByTenantId = async ({ queryKey }: any) => {
    let profileTenantId = queryKey[1];
    return await axiosInstance.get(
      `/Person/GetPersonAndTeamCountByTenantId/?tenantId=${profileTenantId}`
    );
  };

  const GetObjectiveAndKeyResultCountByPeriodId = async ({ queryKey }: any) => {
    let periodId = queryKey[1];
    let profileTenantId = queryKey[2];
    return await axiosInstance.get(
      `/OKR/GetObjectiveAndKeyResultCountByPeriodId/?tenantId=${profileTenantId}&periodId=${periodId}`
    );
  };

const getAllObjectiveByPersonId = async ({ queryKey }: any) => {
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/WebGetAllObjectiveByPersonId/?periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`
  );
};

// https://api.myokr.ir/api/OKR/getAllDefinitionLevelByTenantId?tenantId=3f2d72cf-cdff-413c-abcd-d5459d97890c
// دریافت تیم ها
const getAllObjectiveDefinitionLevelByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  return await axiosInstance.get(
    `OKR/getAllDefinitionLevelByTenantId?tenantId=${tenantId}`
  );
};

const getAllObjectiveDefinitionLevelByTenantId1 = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  let definitionLevelId: string | null = queryKey[2];
  return await axiosInstance.get(
    `OKR/GetAllHorizontalAlignmentByTenantId?tenantId=${tenantId}&definitionLevelId=${definitionLevelId}`
  );
};

// دریافت حالت های یک هدف
// https://api.myokr.ir/api/OKR/GetAllOKRStateByTenantId?tenantId=3f2d72cf-cdff-413c-abcd-d5459d97890c
const GetAllObjectiveOKRStateByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  return await axiosInstance.get(
    `OKR/GetAllOKRStateByTenantId?tenantId=${tenantId}`
  );
};

const getAllTeamAndPersonNameByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  return await axiosInstance.get(
    `Team/WebGetAllTeamAndPersonNameByTenantId?tenantId=${tenantId}`
  );
};

const AddObjective = async (ObjectiveData: any) => {
  return await axiosInstance.post(`OKR/AddObjective`, ObjectiveData);
};

const AddObjectiveData = async (ObjectiveData: any) => {
  return await axiosInstance.post(`OKR/AddObjective`, ObjectiveData);
};
const EditObjective = async (ObjectiveData: any) => {
  return await axiosInstance.post(`OKR/EditObjective`, ObjectiveData);
};

const EditObjectiveData = async (ObjectiveData: any) => {
  return await axiosInstance.post(`OKR/EditObjective`, ObjectiveData);
};

const getObjectiveDetails = async ({ queryKey }: any) => {
  let objId: string | null = queryKey[1];
  return await axiosInstance.get(`OKR/GetObjectiveDetailsById/?id=${objId}`);
};

const getKeyResultDetailsById = async ({ queryKey }: any) => {
  let krId: string | null = queryKey[1];
  return await axiosInstance.get(`OKR/GetKeyResultDetailsById/?id=${krId}`);
};

const getObjectiveDetailsById = async ({ queryKey }: any) => {
  let obId: string | null = queryKey[1];
  return await axiosInstance.get(`OKR/GetObjectiveDetailsById/?id=${obId}`);
};

const editKeyResult = async (krData: any) => {
  return await axiosInstance.post("OKR/EditKeyResult", krData);
};

const deleteKr = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/DeleteKeyResult`, delteKrBody);
};

const deleteObjective = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/DeleteObjective`, delteKrBody);
};

const getFilterByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  let periodId = queryKey[2];
  return await axiosInstance.get(
    `OKR/GetFilterByTenantId?tenantId=${tenantId}&periodId=${periodId}`
  );
};

const getAllVerticalAlignmentByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  let periodId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/GetAllVerticalAlignmentByTenantId/?tenantId=${tenantId}&periodId=${periodId}`
  );
};

export {
  GetAllActivePersonByTenantId,
  GetAllActivePersonsByTenantId,
  GetAllHorizontalAlignmentByTenantId,
  GetAllOKRStateByTenantId,
  GetAllScoreLevelsByTenantId,
  AddKeyResult,
  getAllObjectiveByPeriodId,
  GetPersonAndTeamCountByTenantId,
  getAllObjectiveByPeriodId1,
  GetObjectiveAndKeyResultCountByPeriodId,
  getAllObjectiveByPeriodId2,
  getAllObjectiveByPersonId,
  getAllObjectiveDefinitionLevelByTenantId,
  getAllObjectiveDefinitionLevelByTenantId1,
  GetAllObjectiveOKRStateByTenantId,
  AddObjective,
  getObjectiveDetails,
  getKeyResultDetailsById,
  editKeyResult,
  deleteKr,
  EditObjective,
  getAllVerticalAlignmentByTenantId,
  deleteObjective,
  getObjectiveDetailsById,
  getAllObjectiveNameWithKeyResultsByTenantId,
  getAllTeamAndPersonNameByTenantId,
  getFilterByTenantId,
  AddObjectiveData,
  EditObjectiveData,
  getStrategyMapTenantId
};